import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Box, Chip, Paper, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { Button } from '@verantos-dev/shared-components';

import { useConceptGroupsAndAttributes } from './useConceptGroupsAndAttributes';
import { EditConceptGroupAndAttrCard } from '../ConceptGroupCards/EditConceptGroupAndAttrCard';
import { SavedConceptGroupAndAttributeCard } from '../ConceptGroupCards/SavedConceptGroupAndAttributeCard';

interface ConceptGroupsAndAttributesStepProps {
  setRequiredFieldsFilled: (fieldsFilled: boolean) => void;
}
export const ConceptGroupsAndAttributesStep = ({
  setRequiredFieldsFilled,
}: ConceptGroupsAndAttributesStepProps) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const { handleAddConcept, addedConceptCount, addedConcepts, mandatoryAttributeNames } =
    useConceptGroupsAndAttributes({ setRequiredFieldsFilled });
  return (
    <Box id="concept-groups-and-attributes-step">
      <Paper
        sx={{
          p: theme.spacing(6),
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(6),
        }}
      >
        <Typography variant="h6">
          {formatMessage({ id: 'createProjectWizard.step.conceptGroupsAndAttributes.title' })}
        </Typography>
        <Box>
          <Chip
            label={formatMessage(
              {
                id: 'createProjectWizard.step.conceptGroupsAndAttributes.addedConceptCount.chip.label',
              },
              { count: addedConceptCount }
            )}
            variant="outlined"
            size="small"
            sx={{
              backgroundColor: theme.palette.grey[200],
              fontSize: '13px',
              border: 0,
            }}
          />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(2) }}>
          {addedConcepts.map((concept) =>
            concept.inEditMode ? (
              <EditConceptGroupAndAttrCard key={concept.conceptCardId} concept={concept} />
            ) : (
              <SavedConceptGroupAndAttributeCard
                key={concept.conceptCardId}
                concept={concept}
                mandatoryAttributeNames={mandatoryAttributeNames}
              />
            )
          )}
        </Box>
        <Box>
          <Button
            startIcon={<AddCircleOutlineIcon />}
            variant="contained"
            onClickHandler={() => handleAddConcept()}
            disabled={addedConcepts.some((c) => c.inEditMode)}
            sx={{
              textTransform: 'none',
              fontSize: '14px',
              backgroundColor: theme.palette.primary.main,
            }}
            id="add-concept-button"
            displayLabel={formatMessage({
              id: 'createProjectWizard.step.conceptGroupsAndAttributes.addConceptButton',
            })}
          />
        </Box>
      </Paper>
    </Box>
  );
};
